export const APP_NAME = "SFCC Doc";
export const PRIVACY_POLICY_URL = "https://www.ni18.in/privacy-policy";
export const ABOUT_US_URL = "https://www.ni18.in/about";
export const GIT_HUB_URL = "https://github.com/SalesforceCommerceCloud";
export const STOREFRONT_URL = "https://production-sitegenesis-dw.demandware.net/s/RefArch/home";